import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const GetContentUrl: DocumentNode = gql`
    query GetContentUrl {
        getContentUrl {
            url
        }
    }
`;
